import { LaunchpadCard } from '../../ui/LaunchpadCard';
import { Button, TableCell, TableRow, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import { format } from 'date-fns';
import { EmptyTable } from '../../utils/EmtpyTable';
import { useState } from 'react';
import { NotaryUploadDialog } from './NotaryUploadDialog';
import { NotaryDate } from '../../../models';
import { useTranslation } from 'react-i18next';

interface Props {
  assetId: string;
  dates: NotaryDate[];
  openSuccessAlert: () => void;
}

export const NotaryDatesSection = ({ assetId, dates, openSuccessAlert }: Props) => {
  const [isUploadDialogOpen, setIsUploadDialogOpen] = useState<boolean>(false);
  const datesEmpty = dates.length === 0;
  const { t } = useTranslation();

  return (
    <LaunchpadCard>
      <NotaryUploadDialog
        isOpen={isUploadDialogOpen}
        assetId={assetId}
        closeDialog={() => {
          setIsUploadDialogOpen(false);
        }}
        openSuccessAlert={openSuccessAlert}
      />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '12px', paddingBottom: '24px' }}>
        <Typography gutterBottom variant="h6">
          {t('dashboard.assets.notary.dates.title')}
        </Typography>
        <Button variant="contained" color="primary" startIcon={<Add />} onClick={() => setIsUploadDialogOpen(true)}>
          {t('dashboard.assets.notary.dates.uploadBtnLabel')}
        </Button>
      </div>
      <TableContainer>
        <Table style={{ borderCollapse: 'separate' }}>
          <TableHead>
            <TableRow>
              <TableCell>{t('dashboard.assets.notary.dates.table.header.date')}</TableCell>
              <TableCell>{t('dashboard.assets.notary.dates.table.header.booked')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!datesEmpty &&
              dates.map(({ date, userId }) => {
                const dateObj = new Date(date);
                return (
                  <TableRow key={date} hover onClick={() => true}>
                    <TableCell>{format(dateObj, 'dd.MM.yyyy, HH:mm')}</TableCell>
                    <TableCell>
                      {userId
                        ? t('dashboard.assets.notary.dates.table.field.booked')
                        : t('dashboard.assets.notary.dates.table.field.notBooked')}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
        {datesEmpty && <EmptyTable bottomText={t('dashboard.assets.notary.dates.table.emptyText')} />}
      </TableContainer>
      {/* TODO: add pagination */}
    </LaunchpadCard>
  );
};
